import React from 'react';
import { Container, Box, Heading, Text, Flex, Button, Grid, GridItem } from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import Image from 'next/image';
import { PrimaryButton, OutlineButton } from '../../LightLP/Button';
import SalaryCalculatorContactHandler from '../../Forms/SalaryCalculatorContactHandler';
import ArrowRight from '../../Icons/ArrowRight';
import slugify from '../../../helpers/slugify';
import { useRouter } from 'next/router';
import bluderSalary from '../../../public/images/calculator/blured-salary.svg';

const skills1 = [
  'JavaScript',
  'Java',
  'SQL',
  'MySQL',
  'C++/C#/C',
  'HTML',
  'CSS',
  'jQuery',
  'PHP/Laravel',
  'PostgreSQL',
  'Git',
  'Linux',
  'Unix',
  'AngularJS',
  'Spring',
  'Node.js',
  'Oracle',
  'Adobe',
  'API',
  'Drupal',
  'JMeter',
  'Microservices',
  'Postman',
  'PowerBI',
  'Sketch',
  'SoapUI',
  'TestComplete',
];

const skills2 = [
  'Python',
  'Django',
  'React.js',
  'AWS',
  'Typescript',
  'React Native',
  'Android',
  'Swift',
  'iOS',
  '.NET',
  'Selenium',
  'MongoDB',
  'Ruby',
  'Jenkins',
  'Appium',
  'Cucumber.js',
  'Cypress.js',
  'Firebase',
  'Flask',
  'GitLab',
  'ionic',
  'Mocha',
  'NextUI',
  'Puppet',
  'Redis',
  'Tableau',
  'XCode',
];

const skills3 = [
  'GCP',
  'GoLang',
  '.NET Core',
  'Docker',
  'Vue.js',
  'Ember.js',
  'Express.js',
  'Azure',
  'NoSQL',
  'Apache Spark',
  'Elasticsearch',
  'Machine Learning',
  'Scala',
  'Eclipse',
  'Kotlin',
  'Clojure',
  'GraphQL',
  'Netsuite/Salesforce',
  'Payments',
  'Lambda',
  'Hadoop',
  'Objective-C',
  'Ansible',
  'DynamoDB',
  'Data Warehouse',
  'Big Data',
  'Geospatial',
  'Maven',
  'DataDog',
  'Jeast',
  'Neo4J',
  'RabbitMQ',
  'Sinatra',
  'Snowflake',
  'Xamarin',
];

const skills4 = [
  'Terraform',
  'Kubernetes',
  'Cassandra',
  'Cocoa',
  'Apache Kafka',
  'Chef',
  'Cloudera',
  'Elixir',
  'Erlang',
  'Redshift',
  'Blockchain/Fintech',
  'Tensorflow',
  'Flink',
  'F#',
  'COBOL',
  'Athena',
  'CloudFront',
  'Dropwizard',
  'Apache Airflow',
  'Cordova',
  'Flutter',
  'NumPY',
  'Pandas',
  'Splunk',
];

const AllSkills = () => {
  const skillsOptions = [];
  skills1.map((item) => {
    skillsOptions.push({
      title: item,
      point: 1,
    });
  });

  skills2.map((item) => {
    skillsOptions.push({
      title: item,
      point: 2,
    });
  });

  skills3.map((item) => {
    skillsOptions.push({
      title: item,
      point: 3,
    });
  });

  skills4.map((item) => {
    skillsOptions.push({
      title: item,
      point: 4,
    });
  });

  return skillsOptions.sort((a, b) =>
    slugify(a.title) > slugify(b.title) ? 1 : slugify(b.title) > slugify(a.title) ? -1 : 0,
  );
};

interface StepData {
  name: string;
  title: string;
  multiple: boolean;
  long: boolean;
  items: {
    title: string;
    point: number;
    icon: string;
  }[];
}

const stepData: StepData[] = [
  {
    name: 'country',
    title: "Select the country you're open to hiring from:",
    multiple: false,
    long: false,
    items: [
      {
        title: 'Canada',
        icon: '/images/calculator/canada.svg',
        point: 1,
      },
      {
        title: 'Latin America',
        icon: '/images/calculator/latam.png',
        point: 2,
      },
      {
        title: 'Poland',
        icon: '/images/calculator/poland.svg',
        point: 3,
      },
      {
        title: 'Spain',
        icon: '/images/calculator/spain.svg',
        point: 4,
      },
    ],
  },
  {
    name: 'experienceLevel',
    title: 'What level of engineer (or how many years of experience) ?',
    multiple: false,
    long: true,
    items: [
      {
        title: 'Level 2 (2-5 years)',
        icon: '/images/calculator/star-2.svg',
        point: 1,
      },
      {
        title: 'Level 3 (5-8 years)',
        icon: '/images/calculator/star-3.svg',
        point: 2,
      },
      {
        title: 'Level 4 (8-12 years)',
        icon: '/images/calculator/star-4.svg',
        point: 3,
      },
      {
        title: 'Level 5 (12+ years)',
        icon: '/images/calculator/star-5.svg',
        point: 4,
      },
    ],
  },
  {
    name: 'codeLanguages',
    title: 'What code languages are you looking to hire? (select multiple by scrolling the list)',
    multiple: true,
    long: false,
    items: AllSkills(),
  },
  {
    name: 'educationLevel',
    title: 'What level of education do you require?',
    multiple: false,
    long: true,
    items: [
      {
        title: 'No Degree',
        point: 1,
        icon: '/images/calculator/no-degree.svg',
      },
      {
        title: "Bootcamp / Bachelor's",
        point: 2,
        icon: '/images/calculator/bootcamp-bachelor.svg',
      },
      {
        title: "Master's / Advanced",
        point: 3,
        icon: '/images/calculator/masters-advanced.svg',
      },
      {
        title: 'PhD',
        point: 4,
        icon: '/images/calculator/phd.svg',
      },
    ],
  },
  {
    name: 'benefitsLevel',
    title: 'What level of benefits do you want to provide?',
    multiple: false,
    long: false,
    items: [
      {
        title: 'None',
        point: 1,
        icon: '/images/calculator/benefits-none.svg',
      },
      {
        title: 'Simple',
        point: 2,
        icon: '/images/calculator/benefits-simple.svg',
      },
      {
        title: 'Advanced',
        point: 3,
        icon: '/images/calculator/benefits-advanced.svg',
      },
      {
        title: 'Premium',
        point: 4,
        icon: '/images/calculator/benefits-premium.svg',
      },
    ],
  },
];

const Result = ({
  icon,
  title,
  cost,
  borderColor,
}: {
  icon: string;
  title: string;
  cost: string | React.ReactNode;
  borderColor?: string;
}) => (
  <Box
    p="2.5rem 2rem"
    borderColor={borderColor ?? '#ABB6BA'}
    borderWidth={borderColor ? '0.125rem' : '0.0625rem'}
    borderRadius="0.75rem"
  >
    <Flex>
      <Image src={icon} alt="" width="72" height="72" />
      <Box ml="5">
        <Box fontSize={{ base: '1.125rem', lg: '1.375rem' }} fontWeight="semibold" mb="6">
          {title}
        </Box>
        <Box fontSize={{ base: '1.5rem', lg: '2rem' }} fontWeight="bold" display="flex">
          $ {cost}
        </Box>
      </Box>
    </Flex>
  </Box>
);

const estimateIncludes = [
  'Country',
  'Engineer level',
  'Tech stack',
  'Education level',
  'Benefits level',
];

const salaryLevels = [
  {
    country: 'US',
    salary: [100000, 145000, 164000, 179000],
  },
  {
    country: 'Canada',
    salary: [82000, 109000, 133770, 162967],
  },
  {
    country: 'Latin America',
    salary: [68000, 85500, 99000, 113224],
  },
  {
    country: 'Poland',
    salary: [81000, 96840, 101000, 104760],
  },
  {
    country: 'Spain',
    salary: [50000, 65000, 78200, 90840],
  },
];

const codeLangCoef = [0.95, 1, 1.1, 1.15];

const educationCoef = [0.95, 1, 1.1, 1.2];

const benefitsCoef = [1, 1.01, 1.02, 1.03];

export default function Calculator({
  withStart,
  rounded = true,
  blurred = false,
  theme,
}: {
  withStart: boolean;
  rounded?: boolean;
  blurred?: boolean;
  theme: {
    green100?: string;
    green200?: string;
    green300?: string;
  };
}) {
  interface Answer {
    country: {
      name: string;
      point: number;
    };
    experienceLevel: {
      name: string;
      point: number;
    };
    codeLanguages: {
      name: string;
      point: number;
    }[];
    educationLevel: {
      name: string;
      point: number;
    };
    benefitsLevel: {
      name: string;
      point: number;
    };
  }

  const [step, setStep] = useState<number>(1);
  const [answer, setAnswer] = useState<Answer>({
    country: {
      name: '',
      point: 0,
    },
    experienceLevel: {
      name: '',
      point: 0,
    },
    codeLanguages: [],
    educationLevel: {
      name: '',
      point: 0,
    },
    benefitsLevel: {
      name: '',
      point: 0,
    },
  });
  const [toggleForm, setToggleForm] = useState<boolean>(false);
  const [completed, setCompleted] = useState<boolean>(false);
  const [started, setStarted] = useState<boolean>(false);

  const router = useRouter();
  let variant = router.query.v;
  if (blurred) variant = '1';
  const submitted = router.query.s;

  const maxSteps: number = stepData.length;
  const barWidth: string = (step / maxSteps) * 100 + '%';

  useEffect(() => {
    if (sessionStorage?.salaryCalculator) {
      setCompleted(true);
      setStarted(true);
      setAnswer(JSON.parse(sessionStorage.salaryCalculator));
    }
    if (variant === '1' && router.query.s !== '1') {
      setToggleForm(true);
    }
    if (sessionStorage?.salaryCalculatorSubmitted && router.query.s !== '1') {
      setToggleForm(false);
      router.replace(
        {
          query: { ...router.query, s: '1' },
        },
        undefined,
        { shallow: true },
      );
    }
    if (!withStart) {
      setStarted(true);
    }
  }, [setCompleted, variant, router, withStart]);

  const handleAnswerClick = (
    event: React.MouseEvent<HTMLElement>,
    answerKey: string,
    multiple: boolean,
  ) => {
    const value = event.currentTarget.dataset.value;
    const point = event.currentTarget.dataset.point;

    if (multiple) {
      setAnswer({
        ...answer,
        // add/remove on click
        [answerKey]: answer[answerKey].some((v) => v.name === value)
          ? answer[answerKey].filter((f) => f.name !== value)
          : answer[answerKey].concat([
              {
                name: value,
                point: point,
              },
            ]),
      });
    } else {
      setAnswer({
        ...answer,
        [answerKey]: {
          name: value,
          point: point,
        },
      });
    }
  };

  const handleReset = () => {
    setAnswer({
      country: {
        name: '',
        point: 0,
      },
      experienceLevel: {
        name: '',
        point: 0,
      },
      codeLanguages: [],
      educationLevel: {
        name: '',
        point: 0,
      },
      benefitsLevel: {
        name: '',
        point: 0,
      },
    });
    setCompleted(false);
    setStep(1);
    sessionStorage.removeItem('salaryCalculator');
    if (sessionStorage?.salaryCalculatorSubmitted) {
      setToggleForm(false);
    }
  };

  const currentStepData = (stepData: StepData[], step: number) => stepData[step - 1];

  const nextStep = () => {
    if (step < maxSteps) {
      setStep(step + 1);
    }
    if (step === maxSteps) {
      setCompleted(true);
      sessionStorage.salaryCalculator = JSON.stringify(answer);
    }
  };

  const filledStep = (multiple: boolean) => {
    // get current answer key (ex. industry)
    const key = Object.keys(answer)[step - 1];
    // get current stepData name (ex. 'industry')
    const name = stepData[step - 1].name;

    const filledValue = multiple ? answer[key].length > 0 : answer[key].name.length > 0;

    // check if on current step and answer is filled (toString - can be string or array)
    if (key === name && filledValue) {
      return true;
    } else {
      return false;
    }
  };

  const data = currentStepData(stepData, step);

  const calculateResults = (customCountry?: string) => {
    if (customCountry && !salaryLevels.some((s) => s.country === customCountry)) {
      console.error('Country is not in the list of countries');
      return '0';
    }

    const storedAnswer: Answer = JSON.parse(sessionStorage.salaryCalculator);

    const salaryByLevel = salaryLevels.find(
      (s) => s.country === (customCountry ?? storedAnswer.country.name),
    ).salary[storedAnswer.country.point - 1];

    const codeLangMaxPoint = Math.max(...storedAnswer.codeLanguages.map((lang) => lang.point));

    const salaryByCodeLang = salaryByLevel * codeLangCoef[codeLangMaxPoint - 1];

    const salaryByEducation =
      salaryByCodeLang * educationCoef[storedAnswer.educationLevel.point - 1];

    const salaryByBenefits = salaryByEducation * benefitsCoef[storedAnswer.benefitsLevel.point - 1];

    const roundToThousand = Math.round(salaryByBenefits / 1000) * 1000;

    return roundToThousand.toLocaleString();
  };

  return (
    <Box bgColor="bg.secondary">
      <Container py={{ base: '12', lg: '24' }} id="get-started">
        {withStart && (
          <Box textAlign="center" display={started ? 'none' : 'block'}>
            <Image src="/images/calculator/calculator-start.svg" alt="" width="456" height="322" />
            <Heading
              as="h2"
              textAlign="center"
              mt={{ base: '9', lg: '12' }}
              mb={{ base: '3', lg: '6' }}
              fontSize={{ base: '2rem', lg: '2.625rem' }}
            >
              How Much to Hire Abroad vs Domestically?
            </Heading>
            <Text
              fontSize={{ base: '1.125rem', lg: '1.5rem' }}
              lineHeight={{ base: '1.375rem', lg: '1.75rem' }}
              color="grey.700"
              fontWeight="semibold"
              maxW="66.5rem"
              mx="auto"
              mb={{ base: '8', lg: '12' }}
            >
              Have you ever wondered how much it costs to hire an engineer in a country abroad vs
              hiring domestically or in the US? Terminal’s free cost calculator can help answer that
              question so you can more effectively budget for your global team!
            </Text>
            <PrimaryButton
              theme={theme}
              minW={{ base: '100%', md: '16rem' }}
              position="relative"
              onClick={() => setStarted(true)}
              borderRadius={rounded ? '0.25rem' : '0'}
              _hover={{
                backgroundColor: theme.green300,
                boxShadow: rounded ? '0 0.25rem 0.5rem rgba(0, 0, 0, 0.12)' : 'none',
              }}
            >
              Try Our Free Calculator
              <ArrowRight
                display={{ base: 'none', lg: 'block' }}
                position={{ lg: 'absolute' }}
                right={{ lg: '4' }}
              />
            </PrimaryButton>
          </Box>
        )}
        <Box display={started ? 'block' : 'none'}>
          <Heading
            as="h2"
            textAlign="center"
            mb={{ base: '3', lg: '6' }}
            fontSize={{ base: '2rem', lg: '2.625rem' }}
          >
            Hiring Cost Calculator
          </Heading>
          <Text
            fontSize={{ base: '1.125rem', lg: '1.5rem' }}
            lineHeight={{ base: '1.375rem', lg: '1.75rem' }}
            color="grey.700"
            fontWeight="semibold"
            maxW="66.5rem"
            mx="auto"
            mb={{ base: '8', lg: '12' }}
          >
            Terminal’s free cost calculator shows you the cost to hire an engineer in a country
            abroad vs hiring domestic or US so you can more effectively budget for your global team!
          </Text>
          <Box
            bgColor="white"
            boxShadow="0rem 0.5rem 1rem rgba(0, 0, 0, 0.08)"
            borderRadius="1rem"
            p={{ base: '1.5rem', lg: '3rem' }}
            display={completed && 'none'}
          >
            <Box fontSize="lg" lineHeight="1.5rem" textAlign="center" fontWeight="semibold">
              Step {step} of {maxSteps}
            </Box>
            <Box
              position="relative"
              mt="6"
              mb={{ base: '8', lg: '12' }}
              mx="auto"
              w="100%"
              h="2"
              maxW="36.25rem"
              borderRadius="6.25rem"
              overflow="hidden"
            >
              <Box w="100%" h="100%" bgColor={theme.green100} />
              <Box
                w={barWidth}
                h="100%"
                bgColor={theme.green200}
                position="absolute"
                top="0"
                left="0"
                transition="width 0.3s ease-in-out"
              />
            </Box>
            <Heading
              as="h3"
              textAlign="center"
              fontSize="1.5rem"
              lineHeight="1.75rem"
              fontWeight="semibold"
              mb={{ base: '4', lg: '5' }}
            >
              {data.title}
            </Heading>
            <Box
              maxH={{ base: '20rem', lg: '23rem' }}
              overflow="scroll"
              p={{
                base: '0.0625rem 1rem',
                lg: data.multiple ? '0.0625rem 1rem' : '0.0625rem',
              }}
              maxW="43.875rem"
              mx="auto"
              sx={{
                '::-webkit-scrollbar': {
                  webkitAppearance: 'none',
                  width: { base: '3px', lg: '6px' },
                  height: '0',
                },
                ' ::-webkit-scrollbar-thumb': {
                  borderRadius: '4px',
                  backgroundColor: 'rgba(0, 0, 0, .4)',
                },
              }}
            >
              <Grid
                gap={{ base: '4', lg: '5' }}
                gridTemplateColumns={{
                  lg: `repeat(2, ${data.multiple ? '1fr' : '10rem'})`,
                }}
                justifyContent={{ lg: 'center' }}
              >
                {data.items.map((item, itemIndex) => {
                  const activeLink = data.multiple
                    ? answer[data.name].some((v) => v.name === item.title)
                    : answer[data.name].name.includes(item.title);
                  return (
                    <Button
                      key={itemIndex}
                      display="flex"
                      position="relative"
                      alignItems="center"
                      px={{ base: '4', lg: data.multiple ? '4' : '0' }}
                      h={{ lg: data.multiple ? 'auto' : '10rem' }}
                      minH={{
                        base: '4.125rem',
                        lg: data.multiple ? '2.75rem' : '0',
                      }}
                      whiteSpace="normal"
                      _hover={{
                        textDecoration: 'none',
                      }}
                      borderWidth="0.0625rem"
                      borderStyle="solid"
                      borderColor={activeLink ? theme.green200 : 'grey.300'}
                      borderRadius={{ base: '0.5rem' }}
                      outline={activeLink ? `0.0625rem solid ${theme.green200}` : 'none'}
                      _active={{
                        bgColor: 'transparate',
                      }}
                      _focus={{
                        outline: `0.0625rem solid ${activeLink && theme.green200}`,
                      }}
                      bgColor={{
                        base: activeLink ? theme.green100 : 'white',
                        lg: 'white',
                      }}
                      onClick={(event) => handleAnswerClick(event, data.name, data.multiple)}
                      disabled={data.multiple && !activeLink && answer[data.name].length > 4}
                      data-value={item.title}
                      data-point={item.point}
                    >
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        w={{ base: '4', lg: '4' }}
                        h={{ base: '4', lg: '4' }}
                        mr={{ base: '3', lg: data.multiple ? '3' : '0' }}
                        borderRadius="50%"
                        borderWidth={data.multiple ? '0.0625rem' : '0.125rem'}
                        borderStyle="solid"
                        borderColor={activeLink ? theme.green200 : '#DADADA'}
                        flexShrink={0}
                        position={{ lg: data.multiple ? 'static' : 'absolute' }}
                        top={{ lg: '3' }}
                        right={{ lg: '3' }}
                      >
                        <Box
                          w={data.multiple ? '1.1875rem' : '0.4375rem'}
                          h={data.multiple ? '1.1875rem' : '0.4375rem'}
                          bgColor={activeLink ? theme.green200 : 'transparent'}
                          borderRadius="50%"
                          flexShrink={0}
                        />
                        <Box display={data.multiple ? 'block' : 'none'} position="absolute">
                          <svg width="12px" height="8px" viewBox="0 0 14 10">
                            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                              <g id="check_circle_24px" fill="#FFFFFF">
                                <path
                                  d="M0.7,5.7 L4.29,9.29 C4.68,9.68 5.32,9.68 5.7,9.29 L13.29,1.7 C13.68,1.31 13.68,0.68 13.29,0.29 C12.9,-0.1 12.27,-0.1 11.88,0.29 L5,7.17 L2.11,4.29 C1.72,3.9 1.09,3.9 0.7,4.29 C0.51275,4.4768 0.40751,4.7305 0.40751,4.995 C0.40751,5.2595 0.51275,5.5132 0.7,5.7 Z"
                                  id="Path"
                                />
                              </g>
                            </g>
                          </svg>
                        </Box>
                      </Box>
                      <Flex
                        flexDirection={{
                          base: 'row',
                          lg: data.multiple ? 'row' : 'column',
                        }}
                        w="100%"
                        h="100%"
                        alignItems="center"
                        justifyContent={{
                          base: 'space-between',
                          lg: data.multiple ? 'space-between' : 'flex-end',
                        }}
                      >
                        {item.icon && (
                          <Box
                            display={{
                              base: 'none',
                              lg: data.multiple ? 'none' : 'block',
                            }}
                          >
                            <Image src={item.icon} alt="12" width="64" height="64" />
                          </Box>
                        )}
                        <Box
                          mt={{ lg: data.multiple ? '0' : '2' }}
                          minH={{ lg: data.multiple ? '0' : '2.125rem' }}
                          fontSize={{
                            base: '1.125rem',
                            lg: data.multiple ? '1rem' : '0.875rem',
                          }}
                          lineHeight={{
                            base: '1.25rem',
                            lg: data.multiple ? '1.375rem' : '1.125rem',
                          }}
                          fontWeight="semibold"
                        >
                          <Text>{item.title}</Text>
                        </Box>
                        {item.icon && (
                          <Box
                            display={{
                              base: 'flex',
                              lg: data.multiple ? 'flex' : 'none',
                            }}
                            alignItems="center"
                            justifyContent="center"
                            width="2.5rem"
                            height="2.5rem"
                            bgColor={activeLink ? 'white' : ''}
                            borderRadius="50%"
                            flexShrink={0}
                          >
                            <Image src={item.icon} alt="" width="24" height="24" />
                          </Box>
                        )}
                      </Flex>
                    </Button>
                  );
                })}
              </Grid>
            </Box>
            <Box
              display="flex"
              flexDirection={{ base: 'column', lg: 'row' }}
              mt={{ base: '4', lg: '12' }}
              justifyContent="center"
            >
              {step != 1 && (
                <OutlineButton
                  theme={theme}
                  minW={{ base: '100%', md: '10.25rem' }}
                  position="relative"
                  order={{ base: 1, lg: 0 }}
                  onClick={() => setStep(step - 1)}
                  borderRadius={rounded ? '0.25rem' : '0'}
                  _hover={{
                    backgroundColor: theme.green200,
                    color: 'white',
                    boxShadow: rounded ? '0 0.25rem 0.5rem rgba(0, 0, 0, 0.12)' : 'none',
                  }}
                >
                  Previous{' '}
                  <ArrowRight
                    display={{ base: 'none', lg: 'block' }}
                    position={{ lg: 'absolute' }}
                    left={{ lg: '4' }}
                    transform="rotate(180deg)"
                    transition="none"
                  />
                </OutlineButton>
              )}
              <PrimaryButton
                theme={theme}
                minW={{ base: '100%', md: '10.25rem' }}
                position="relative"
                mb={{ base: '4', lg: '0' }}
                ml={{ base: '0', lg: '4' }}
                onClick={() => nextStep()}
                disabled={!filledStep(data.multiple)}
                borderRadius={rounded ? '0.25rem' : '0'}
                _hover={{
                  backgroundColor: theme.green300,
                  boxShadow: rounded ? '0 0.25rem 0.5rem rgba(0, 0, 0, 0.12)' : 'none',
                }}
              >
                {step === maxSteps ? 'Continue' : 'Next'}{' '}
                <ArrowRight
                  display={{ base: 'none', lg: 'block' }}
                  position={{ lg: 'absolute' }}
                  right={{ lg: '4' }}
                />
              </PrimaryButton>
            </Box>
          </Box>
          <Box
            bgColor="white"
            boxShadow="0rem 0.5rem 1rem rgba(0, 0, 0, 0.08)"
            borderRadius="1rem"
            overflow="hidden"
            display={!completed && 'none'}
          >
            <Grid gridTemplateColumns={{ lg: toggleForm && '1fr 1fr' }}>
              <GridItem>
                <Box p={{ base: '1.5rem', lg: '2.5rem 2rem 2.5rem 2rem' }}>
                  <Heading
                    as="h3"
                    fontSize={{ base: '1.5rem', lg: '2rem' }}
                    textAlign="center"
                    mb={{ base: '6', lg: '10' }}
                  >
                    Results
                  </Heading>
                  <Grid
                    gridTemplateColumns={{
                      lg: !toggleForm && '1fr 1fr',
                    }}
                    gap="6"
                    mb={{ base: '6', lg: '10' }}
                  >
                    <GridItem>
                      <Result
                        icon="/images/calculator/world.svg"
                        title="Cost to hire abroad with Terminal"
                        cost={
                          completed ? (
                            variant === '1' && submitted !== '1' ? (
                              <Image src={bluderSalary} alt="" />
                            ) : (
                              calculateResults()
                            )
                          ) : (
                            '0'
                          )
                        }
                        borderColor={theme.green200}
                      />
                    </GridItem>
                    <GridItem>
                      <Result
                        icon="/images/calculator/usa.svg"
                        title="Cost to hire in the US"
                        cost={
                          completed ? (
                            variant === '1' && submitted !== '1' ? (
                              <Image src={bluderSalary} alt="" />
                            ) : (
                              calculateResults('US')
                            )
                          ) : (
                            '0'
                          )
                        }
                      />
                    </GridItem>
                  </Grid>
                  <Heading as="h4" textAlign="center" fontSize="1rem" mb={{ base: '3', lg: '6' }}>
                    What we’ve included in our estimate
                  </Heading>
                  <Box maxW="28.125rem" mx="auto">
                    <Flex flexWrap="wrap" alignItems="center" justifyContent="space-between">
                      {estimateIncludes.map((item) => (
                        <Box
                          key={item}
                          mb="1rem"
                          mx={!toggleForm && 'auto'}
                          display="inline-block"
                          p="0.25rem 0.875rem"
                          color={theme.green300}
                          bgColor={theme.green100}
                          borderRadius="6.25rem"
                          fontSize="sm"
                          lineHeight="1.125rem"
                          flexShrink={0}
                        >
                          {item}
                        </Box>
                      ))}
                    </Flex>
                  </Box>
                  <Box
                    display="flex"
                    flexDirection={{ base: 'column', lg: 'row' }}
                    mt={{ base: '4', lg: toggleForm ? '4' : '12' }}
                    justifyContent="center"
                  >
                    <OutlineButton
                      theme={theme}
                      minW={{ base: '100%', md: '10.25rem' }}
                      position="relative"
                      order={{ base: 1, lg: 0 }}
                      onClick={() => handleReset()}
                      borderRadius={rounded ? '0.25rem' : '0'}
                      _hover={{
                        backgroundColor: theme.green200,
                        color: 'white',
                        boxShadow: rounded ? '0 0.25rem 0.5rem rgba(0, 0, 0, 0.12)' : 'none',
                      }}
                    >
                      <ArrowRight mr="3" transform="rotate(180deg)" transition="none" />
                      Start Over
                    </OutlineButton>
                    {!toggleForm && submitted !== '1' && (
                      <PrimaryButton
                        theme={theme}
                        minW={{ base: '100%', md: '16rem' }}
                        position="relative"
                        mb={{ base: '4', lg: '0' }}
                        ml={{ base: '0', lg: '4' }}
                        onClick={() => setToggleForm(true)}
                        borderRadius={rounded ? '0.25rem' : '0'}
                        _hover={{
                          backgroundColor: theme.green300,
                          boxShadow: rounded ? '0 0.25rem 0.5rem rgba(0, 0, 0, 0.12)' : 'none',
                        }}
                      >
                        Get Started With Terminal
                      </PrimaryButton>
                    )}
                  </Box>
                </Box>
              </GridItem>
              {toggleForm && (
                <GridItem
                  bgColor="grey.100"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Box py={{ lg: '2rem' }}>
                    {submitted === '1' ? (
                      <Box py="2rem" mb="6" textAlign="center" mx="auto" maxW="450px">
                        <Box
                          fontSize="2rem"
                          line-height="2.25rem"
                          fontWeight="bold"
                          color="grey.900"
                        >
                          <Box color={theme.green200}>Thank you</Box>
                          <Box>for your interest.</Box>
                        </Box>
                        <Text mt="6" lineHeight="shorter" fontSize={{ base: 'md', lg: 'lg' }}>
                          A Terminal hiring expert will be in touch shortly to answer any questions
                          you may have after reviewing the results of your salary-saving potential.
                        </Text>
                      </Box>
                    ) : (
                      <SalaryCalculatorContactHandler
                        title={
                          variant === '1'
                            ? 'Want to see your results now?'
                            : 'Get Started With Terminal'
                        }
                        theme={theme}
                        buttonText={variant === '1' ? 'See My Results' : 'Get Started'}
                        completed={completed}
                        rounded={rounded}
                      />
                    )}
                  </Box>
                </GridItem>
              )}
            </Grid>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
